module.exports = __webpack_public_path__ + "img/facebook.8ff99d34.svg";